<template>
  <div>
    <b-table
      :fields="fields"
      :items="keywords[keywordPage]"
      show-empty
      responsive
      class="merchant-dashboard__table scroll-area-horizontal">
      <div
        slot="keyword"
        slot-scope="data"
        tag="div">{{ keywordName(data.item.keyword) }}</div>
      <div
        slot="details"
        slot-scope="data"
        class="text-right">
        <span
          class="open-chart"
          @click="openKeywordChart(data.item)">
          <icon name="chart-bar"/>
        </span>
      </div>
      <div
        v-if="!keywords.length"
        slot="empty"
        class="no-data text-center">
        <span class="d-block">
          No keywords found.
        </span>
      </div>
    </b-table>
    <div class="paging clearfix">
      <p class="float-left pages">{{ page }} of {{ keywords.length }}</p>
      <button
        :disabled="page === keywords.length"
        class="btn btn-default btn-paging float-right"
        @click="nextPage">Next</button>
      <button
        :disabled="page === 1"
        class="btn btn-default btn-paging float-right"
        @click="previousPage">Back</button>
    </div>
    <KeywordChartModal
      ref="keywordChartModal"
      :dates="dates"
      :chart-labels="chartLabels"/>
  </div>
</template>

<script>
import KeywordChartModal from './modals/KeywordChartModal';

export default {
  name: 'AutomationKeywordsTable',
  components: {
    KeywordChartModal,
  },
  props: {
    keywordData: {
      type: Array,
      default: () => [],
    },
    dates: {
      type: Object,
      default: () => {},
    },
    chartLabels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      page: 1,
      pageSize: 5,
      fields: [
        'keyword',
        {
          key: 'all_interactions',
          label: 'All Interactions',
        },
        {
          key: 'unique_interactions',
          label: 'Unique Interactions',
        },
        {
          key: 'details',
          label: '',
        },
      ],
    };
  },
  computed: {
    keywordPage() {
      return this.page - 1;
    },
    keywords() {
      return this.$lodash.chunk(this.keywordData, this.pageSize);
    },
  },
  methods: {
    keywordName(keyword) {
      switch (keyword) {
        case 'default':
          return 'Default Reply';
        case 'away':
          return 'Away Reply';
        default:
          return keyword;
      }
    },
    openKeywordChart(keyword) {
      this.$refs.keywordChartModal.loadAnalytics(keyword);
      this.$refs.keywordChartModal.show();
    },
    previousPage() {
      this.page -= 1;
    },
    nextPage() {
      this.page += 1;
    },
  },
};
</script>
